var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: { value: _vm.dialog, "max-width": "500px" },
          on: {
            "click:outside": function ($event) {
              return _vm.$emit("updateDialog", false)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        staticClass: "mb-5",
                        attrs: { color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("updateDialog", true)
                          },
                        },
                      },
                      on
                    ),
                    [_vm._v(_vm._s(_vm.button_name))]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.createItem.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v(_vm._s(_vm.modal_title)),
                    ]),
                  ]),
                  _c("v-card-text", [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|max:100",
                                expression: "'required|max:100'",
                              },
                            ],
                            attrs: {
                              "data-vv-as": "nombre",
                              label: "Nombre*",
                              name: "name",
                              disabled: _vm.isViewModal(),
                            },
                            model: {
                              value: _vm.item.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "name", $$v)
                              },
                              expression: "item.name",
                            },
                          }),
                          _c("span", { staticClass: "red--text" }, [
                            _vm._v(_vm._s(_vm.errors.first("name"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              "data-vv-as": "estilo",
                              label: "Estilo en el organigrama*",
                              name: "style",
                              items: _vm.NODE_STYLES,
                              "item-text": "name",
                              "item-value": "id",
                              disabled: _vm.isViewModal(),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function ({ item: style }) {
                                  return [
                                    _c("span", {
                                      staticClass: "oc-swatch mr-3",
                                      class: style.id,
                                    }),
                                    _vm._v(_vm._s(style.name) + " "),
                                  ]
                                },
                              },
                              {
                                key: "selection",
                                fn: function ({ item: style }) {
                                  return [
                                    _c("span", {
                                      staticClass: "oc-swatch mr-3",
                                      class: style.id,
                                    }),
                                    _vm._v(_vm._s(style.name) + " "),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.item.style,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "style", $$v)
                              },
                              expression: "item.style",
                            },
                          }),
                          _c("span", { staticClass: "red--text" }, [
                            _vm._v(_vm._s(_vm.errors.first("style"))),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-caption grey--text text--darken-1",
                            },
                            [
                              _vm._v(
                                "Los estilos Oscuro y Medio muestran además la cantidad de legajos."
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "integer",
                                expression: "'integer'",
                              },
                            ],
                            attrs: {
                              "data-vv-as": "orden",
                              label: "Orden",
                              name: "sort_order",
                              type: "number",
                              disabled: _vm.isViewModal(),
                            },
                            model: {
                              value: _vm.item.sort_order,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "sort_order", $$v)
                              },
                              expression: "item.sort_order",
                            },
                          }),
                          _c("span", { staticClass: "red--text" }, [
                            _vm._v(_vm._s(_vm.errors.first("sort_order"))),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error", text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("updateDialog", false)
                            },
                          },
                        },
                        [_vm._v("Cerrar")]
                      ),
                      !_vm.isViewModal()
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "success",
                                text: "",
                                type: "submit",
                                loading: _vm.loading,
                              },
                            },
                            [_vm._v(_vm._s(_vm.formBtn))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }